import * as React from 'react';
import { Dropdown, IDropdownOption } from 'office-ui-fabric-react';

type ChangeBlockEventHandler = (value: number) => void;

type IContractPartTimeFixBlockModelBlockProps = {
    onChangeBlockDays: ChangeBlockEventHandler;
    onChangeBlockFrequency : ChangeBlockEventHandler;
    onChangeBlockBeginDay: ChangeBlockEventHandler;
    onChangeBlockBeginMonth : ChangeBlockEventHandler;
    blockDays?: number;
    blockFrequency?: number;
    blockBeginDay?: number;
    blockBeginMonth?: number;
    className?: string;
    disabled?: boolean;
};

export class ContractPartTimeFixBlockModelBlock extends React.PureComponent<IContractPartTimeFixBlockModelBlockProps,{}>{
    private _store: ContractPartTimeFixBlockModelBlockStore;

    constructor(props: IContractPartTimeFixBlockModelBlockProps) {
        super(props);
        this._store = new ContractPartTimeFixBlockModelBlockStore(props);
    }

    render(){
        return(
            <React.Fragment>
                <Dropdown
                    label="Block Days"
                    options={this._store.fixBlockDaysOptions}
                    onChange={this._store.onChangeBlockDays}
                    required={true}
                    selectedKey={this.props.blockDays}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                <Dropdown
                    label="Block Frequency"
                    options={this._store.fixBlockFrequencyOptions}
                    onChange={this._store.onChangeBlockFrequency}
                    required={true}
                    selectedKey={this.props.blockFrequency}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                <Dropdown
                    label="Block Begin Day"
                    options={this._store.fixBlockBeginDayOptions}
                    onChange={this._store.onChangeBlockBeginDay}
                    required={true}
                    selectedKey={this.props.blockBeginDay}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
                <Dropdown
                    label="Block Begin Month"
                    options={this._store.fixBlockBeginMonthOptions}
                    onChange={this._store.onChangeBlockBeginMonth}
                    required={true}
                    selectedKey={this.props.blockBeginMonth}
                    className={this.props.className}
                    disabled={this.props.disabled}
                />
            </React.Fragment>
        );
    }
}

class ContractPartTimeFixBlockModelBlockStore {
    private readonly _onChangeBlockDaysFunction: ChangeBlockEventHandler;
    private readonly _onChangeBlockFrequencyFunction: ChangeBlockEventHandler;
    private readonly _onChangeBlockBeginDayFunction: ChangeBlockEventHandler;
    private readonly _onChangeBlockBeginMonthFunction: ChangeBlockEventHandler;

    constructor(props: IContractPartTimeFixBlockModelBlockProps) {
        this._onChangeBlockDaysFunction = props.onChangeBlockDays;
        this._onChangeBlockFrequencyFunction = props.onChangeBlockFrequency;
        this._onChangeBlockBeginDayFunction = props.onChangeBlockBeginDay;
        this._onChangeBlockBeginMonthFunction = props.onChangeBlockBeginMonth;
    }

    onChangeBlockDays = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockDaysFunction(option.key as number);
        }
    };
    onChangeBlockFrequency = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockFrequencyFunction(option.key as number);
        }
    };
    onChangeBlockBeginDay = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockBeginDayFunction(option.key as number);
        }
    };
    onChangeBlockBeginMonth = (event: React.FormEvent<HTMLDivElement>, option?: IDropdownOption) => {
        if (option) {
            this._onChangeBlockBeginMonthFunction(option.key as number);
        }
    };    
    

    get fixBlockDaysOptions() {
        let keys = [];
        for (let i = 1; i < 57; i++){
            keys.push({key: i, text: i.toString()});
        }
        return keys;
    }

    get fixBlockFrequencyOptions() {
        return [
            {key: 1, text: '1'},
            {key: 2, text: '2'},
            {key: 3, text: '3'},
            {key: 4, text: '4'},
            {key: 6, text: '6'},
            {key: 12, text: '12'},
        ];
    }

    get fixBlockBeginDayOptions() {
        let keys = [];
        for (let i = 1; i < 29; i++){
            keys.push({key: i, text: i.toString()});
        }
        return keys;
    }

    get fixBlockBeginMonthOptions() {
        let keys = [];
        for (let i = 1; i < 13; i++){
            keys.push({key: i, text: i.toString()});
        }
        return keys;
    }
}